export const letterRegex = /\p{L}/u;
export const nameRegex = new RegExp(`^${letterRegex.source}+(?:[-' ]${letterRegex.source}+)*$`, "iu");
export const phoneRegex = /^[+]?[0-9() /.-]{1,21}[0-9]$/;
export const zipCodeRegex = /^\d+$/;
